<!-- 企微通码用户引流 -->
<template>
  <div class="wrap">
    <div class="main" :style="{ backgroundImage: `url(${bg})` }" @click="clickPage">
      <div v-if="hasFetch && !qrCode" class="tip">
        链接已失效，请联系客服
      </div>
      <div class="tip" v-if="!qrCode && isHezi && !isHeziLogin">
        请登录盒子账号
      </div>
      <img v-if="qrCode" :src="qrCode" class="qrc" />
    </div>
  </div>
</template>

<script>
import { getQWCommonInfo, getUserByCredentials } from '@/apis/gameJump'
// 创建 webview 环境用
import EventTrack from '@/mixins/eventTrack'
import track from './components/track'
import { getUserInfo, toLogin, turnToSystemWeb } from "@/bridge/AppJsBridge"
import { getCookie, checkIsWxBrowser } from "@/libs/utils";
export default {
  data () {
    return {
      uid: '',
      user_id: '',
      isHezi: false,
      isHeziLogin: false,
      heziAppid: '',
      bg: '',
      qrCode: '',
      general_config_id: '',
      qy_weixin_user: '',
      hasFetch: false,
    }
  },
  mixins: [EventTrack, track],
  created () {
    this.judgeChannel()
  },
  computed: {
    gu () {
      return this.$route.query.gu
    },
    // 一次性验证码
    credential () {
      return this.$route.query.credential
    },
    appkey () {
      return this.isHezi ? this.heziAppid : this.$route.query.appkey
    },
  },
  methods: {
    // 判断投放渠道
    judgeChannel () {
      if (this.credential) {
        // 游戏渠道 - 一次性验收
        this.getUserInfo().then(res => {
          this.getInfo()
        })
      } else if (this.$route.query.user_id) {
        // 视为盒子打开的浏览器
        this.user_id = this.$route.query.user_id
        this.getInfo()
      } else {
        // 可能是盒子，可能是其他的渠道
        this.getHeziAppUid(true)
        // 给判断盒子 500 ms 的时间
        setTimeout(() => {
          // 其他没有 user_id 的情况
          // 盒子没登陆态, 先提示登录, 如果拒绝登录, 表示该用户意愿不强
          if (!this.isHezi) {
            this.getInfo()
          }
          if (checkIsWxBrowser()) {
            document.title = ' '
          }
        }, 500)
      }
    },
    getUserInfo () {
      return getUserByCredentials({
        credential: this.credential,
        appkey: this.appkey || 100000001, // 可以写死，随便给
      }).then(r => {
        console.log(r)
        if (r.ret == 1) {
          this.user_id = r.content.user_id;
          localStorage.setItem('lead_user_id', r.content.user_id);
        } else {
          this.user_id = localStorage.getItem('lead_user_id');
        }
        this.redirect()
      }).catch(() => {
        this.user_id = localStorage.getItem('lead_user_id');
        this.redirect()
      })
    },
    getInfo () {
      getQWCommonInfo({
        user_id: this.user_id,
        gu: this.gu,
      }).then(res => { 
        console.log(res)
        const { status, qr_code, qy_weixin_user, general_config_id, background } = res.content
        if (status === 1) {
          this.bg = background
          this.qrCode = qr_code
          this.qy_weixin_user = qy_weixin_user
          this.general_config_id = general_config_id
          this.buryReport("QY_WEIXIN_GENERAL_SHOW", {
            qy_weixin_user,
            general_config_id,
            user_id: this.user_id,
            appkey: this.appkey,
          });
          this.redirect()
        }
      }).finally(() => {
        this.hasFetch = true
      })
    },
    callOpenBrowser () {
      const { href, search } = window.location
      const prefix = search.includes('?') ? '&' : '?'
      const to = `${href}${prefix}user_id=${this.user_id}&appkey=${this.appkey}`
      turnToSystemWeb({ url: to })
    },
    redirect () {
      if (this.isHezi || checkIsWxBrowser()) return
      const appid = 'wx7ebd52bd136e97d9';
      let data = encodeURIComponent(`user_id=${this.user_id}&gu=${this.gu}`);
      const ENV_VERSION = 'release'; // 正式版为release，体验版为trial，开发版为develop
      console.log('data', data);
      console.log('ENV_VERSION', ENV_VERSION);
      console.log(`weixin://dl/business/?appid=${appid}&path=pages/common/index&query=${data}&env_version=${ENV_VERSION}`);
      window.location.href = `weixin://dl/business/?appid=${appid}&path=pages/common/index&query=${data}&env_version=${ENV_VERSION}`
    },
    // 获取盒子 uid，如果是盒子环境的话
    getHeziAppUid (needCallLogin) {
      const token = getCookie("token")
      const uid = getCookie("uid")
      if (token && uid) {
        // 不能混用 lead_user_id，可能单个用户有多个游戏角色和盒子角色
        // localStorage.setItem("lead_user_id", token);
        this.isHezi = true;
      } else {
        getUserInfo((userInfo) => {
          this.isHezi = true;
          let Info = JSON.parse(userInfo);
          this.isHeziLogin = !!Info.uid
          if (Info.uid) {
            this.user_id = Info.uid;
            this.getInfo()
            this.callOpenBrowser()
          } else {
            if (needCallLogin) {
              toLogin("/loginKey/LoginByKeyPhoneActivity");
            }
          }
        });
      }
    },
    clickPage () {
      // 未登录的盒子用户无交互
      if (this.isHezi && !this.isHeziLogin) return
      // 链接失效
      if (this.hasFetch && !this.qrCode) return
      this.buryReport("QY_WEIXIN_GENERAL_CLICK", {
        qy_weixin_user: this.qy_weixin_user,
        general_config_id: this.general_config_id,
        user_id: this.user_id,
        appkey: this.appkey,
      });
      if (this.isHezi) {
        this.callOpenBrowser()
      } else {
        this.redirect()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  width: 100vw;
  height: 100vh;
  // 有一定程度的拉伸
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 50% 100%;
  .qrc {
    position: absolute;
    right: 44px;
    bottom: 58px;
    width: 140px;
  }
  .tip {
    margin-top: 120px;
    text-align: center;
    font-size: 18px;
  }
}
</style>
